export default __webpack_public_path__ + "static/media/dottedCircle.f3b8707d.svg";